'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventWidget = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(EventWidget, _Component);

  function EventWidget() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EventWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EventWidget.__proto__ || (0, _getPrototypeOf2.default)(EventWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isModalOpen: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EventWidget, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isModalOpen !== this.props.isModalOpen) {
        this.setState({
          isModalOpen: nextProps.isModalOpen
        });
      }
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.props.closeModal();
    }
  }, {
    key: 'requireCloseModal',
    value: function requireCloseModal() {
      this.closeModal();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          polyglot = _props.polyglot,
          calendarId = _props.calendarId,
          url = _props.url;

      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          dialogClassName: 'custom-modal',
          animation: false,
          enforceFocus: false,
          keyboard: false,
          show: this.state.isModalOpen,
          onHide: this.requireCloseModal.bind(this)
        },
        _react2.default.createElement(_components.EventWidgetForm, {
          ref: 'eventWidgetModal',
          calendarId: calendarId,
          requireCloseModal: this.requireCloseModal.bind(this),
          closeModal: this.closeModal.bind(this),
          polyglot: polyglot,
          url: url
        })
      );
    }
  }]);
  return EventWidget;
}(_react.Component), _class.propTypes = {
  isModalOpen: _propTypes2.default.bool,
  calendarId: _propTypes2.default.number,
  closeModal: _propTypes2.default.func,
  polyglot: _propTypes2.default.object.isRequired,
  url: _propTypes2.default.object
}, _temp2);
exports.default = EventWidget;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Event/EventWidget.js
// module id = 2195
// module chunks = 0